import { rngFloat, type RngHolder } from '../math/rng';

// AI misconduct opportunity latches (§8.1). A misconduct temptation (retaliate, tactical foul, dive) is a
// RISING-EDGE roll: the bot rolls aiRng ONCE when the opportunity appears, then must NOT re-roll while it
// persists (per-tick rolls would saturate to certainty). The latch re-arms only after the predicate has
// been false for P_REARM ticks (T-AI-013). Pure apart from the passed aiRng.

export interface Latch {
  held: boolean; // was the predicate true last tick?
  falseTicks: number; // consecutive ticks the predicate has been false
  armed: boolean; // may the next rising edge roll?
}

export function makeLatch(): Latch {
  return { held: false, falseTicks: Number.MAX_SAFE_INTEGER, armed: true };
}

/**
 * Evaluate one misconduct opportunity this tick. Draws aiRng only on an armed rising edge; returns true iff
 * the roll succeeds (the misconduct fires this tick). Re-arms after `rearmTicks` of a false predicate.
 */
export function rollOpportunity(latch: Latch, predicate: boolean, prob: number, rng: RngHolder, rearmTicks: number): boolean {
  if (!predicate) {
    latch.held = false;
    latch.falseTicks += 1;
    if (latch.falseTicks >= rearmTicks) latch.armed = true;
    return false;
  }
  let fired = false;
  if (!latch.held && latch.armed) {
    fired = rngFloat(rng) < prob; // one roll on the rising edge
    latch.armed = false; // spent until the predicate has been false long enough
  }
  latch.held = true;
  latch.falseTicks = 0;
  return fired;
}
